(function () {
  'use strict';

  // Collection descriptions stay in the DOM for search engines but are hidden on
  // screen, so the Read more / Read less clamp is gone along with them.

  function initHeroLinks() {
    try {
      ['__image_banner_bPRRmp', '__image_banner_BLpPRA'].forEach(function (suffix) {
        var section = document.querySelector('[id^="shopify-section-"][id$="' + suffix + '"]');
        if (!section || section.querySelector('.rl-hero-link')) return;
        var a = document.createElement('a');
        a.href = '/collections';
        a.className = 'rl-hero-link';
        a.setAttribute('aria-label', 'Shop the store');
        a.textContent = 'Shop the store';
        section.appendChild(a);
      });
    } catch (e) {
      // never throw
    }
  }

  // Closing a theme preview does not change shared Shopify inventory. Block the native
  // form too, so variant scripts cannot submit a closed drop through a stale button.
  document.addEventListener('submit', function (event) {
    if (event.target.closest('[data-drop-closed="true"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // An upcoming drop keeps its release label on the buy button. The core variant script
  // rewrites the label to "Sold out" on every size change; put the release label back.
  function holdDropLabels() {
    document.querySelectorAll('[data-drop-closed="true"][data-drop-label]').forEach(function (form) {
      var wanted = form.getAttribute('data-drop-label');
      form.querySelectorAll('.main-atc__label__text').forEach(function (label) {
        if (label.dataset.dropLabelHeld) return;
        label.dataset.dropLabelHeld = 'true';
        var fix = function () { if (label.textContent.trim() !== wanted) label.textContent = wanted; };
        new MutationObserver(fix).observe(label, { childList: true, characterData: true, subtree: true });
        fix();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', holdDropLabels);
  else holdDropLabels();
  document.addEventListener('shopify:section:load', holdDropLabels);

  function initVariantDetails() {
    var info = document.querySelector('product-info[id^="ProductInfo-"]');
    var details = info && info.querySelector('[data-runit-purchase-details]');
    var form = info && info.querySelector('form[action*="/cart/add"]:has(button[name="add"])');
    if (!details || !form || info.dataset.runitVariantDetails) return;
    var matchPath = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!matchPath) return;
    fetch((window.Shopify.routes.root || '/') + 'products/' + matchPath[1] + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) return;
        info.dataset.runitVariantDetails = 'true';
        var byId = {};
        product.variants.forEach(function (variant) { byId[variant.id] = variant; });
        var names = product.options.map(function (option) { return option.name || option; });
        var fulfilRoot = details.querySelector('[data-runit-fulfilment]');
        var badge = details.querySelector('[data-runit-fulfilment-badge]');
        var dispatch = details.querySelector('[data-runit-fulfilment-dispatch]');
        var lastPiece = details.querySelector('[data-runit-fulfilment-last]');
        var restockPanel = details.querySelector('[data-runit-restock-panel]');
        var restockCopy = details.querySelector('[data-runit-restock-copy]');
        var restockLead = details.querySelector('[data-runit-restock-lead]');
        var restockForm = details.querySelector('[data-runit-restock-form]');
        var restockMessage = details.querySelector('[data-runit-restock-message]');
        var restockDone = details.querySelector('[data-runit-restock-done]');
        var restockButton = restockForm && restockForm.querySelector('button[type="submit"]');
        var restockEmailInput = restockForm && restockForm.querySelector('[name="email"]');
        // The sold-out variant the panel currently speaks for. Null whenever the
        // selected variant is purchasable, so a submit can never file a waitlist
        // entry against a variant the customer is not actually waiting on.
        var restockVariant = null;
        // Variants this page has already filed a waitlist entry for, so switching
        // back to one shows the confirmation rather than a second empty form.
        // Written only after the storefront answered ok.
        var restockSubscribed = {};
        var mapScript = details.querySelector('[data-runit-fulfilment-map]');
        var states = {};
        try {
          states = JSON.parse((mapScript && mapScript.textContent) || '{}') || {};
        } catch (e) {
          states = {};
        }
        var lastPublishedVariantId = null;

        function publishVariant(variant) {
          if (!variant || lastPublishedVariantId === variant.id) return;
          lastPublishedVariantId = variant.id;
          document.dispatchEvent(new CustomEvent('runit:variant-change', {
            detail: { variant: variant, optionNames: names }
          }));
        }

        // The three states and the copy that goes with each — mirrors snippets/runit-fulfilment-state.liquid.
        var FULFILMENT_COPY = {
          ready: { label: 'Ready to dispatch', dispatch: 'Dispatched in 1 - 3 working days' },
          made: { label: 'Made to order', dispatch: 'Dispatched in 2 weeks' },
          sold: { label: 'Out of stock', dispatch: '' }
        };

        // Shopify inventory, decided per variant and never from quantity alone:
        //   quantity > 0                                     -> ready  (physical stock exists)
        //   quantity <= 0 and policy == 'continue'           -> made   (sellable, made to order)
        //   quantity <= 0 and policy != 'continue'           -> sold   (cannot be sold)
        // Untracked variants (inventory_management != 'shopify') always sell, so they read ready.
        function stateFromInventory(entry) {
          if (!entry) return 'sold';
          if (entry.available === false) return 'sold';
          if (entry.inventory_management !== 'shopify') return 'ready';
          var quantity = Number(entry.inventory_quantity);
          if (!isFinite(quantity)) quantity = 0;
          if (quantity > 0) return 'ready';
          return entry.inventory_policy === 'continue' ? 'made' : 'sold';
        }

        // Fulfilment state comes from Shopify's own per-variant inventory. snippets/runit-fulfilment.liquid
        // resolves it server side and ships the variant map (state, label, dispatch, last-piece flag and
        // policy — never the stock count, which would publish exact stock levels) with the badge, so switching size or finish updates the state with no extra request and
        // no flash of the wrong wording.
        function fulfilmentStateFor(variant) {
          var dropForm = form.closest('[data-drop-closed="true"]');
          if (dropForm) {
            return { state: 'sold', label: dropForm.getAttribute('data-drop-label') || 'Out of stock', dispatch: '', last: false };
          }
          var entry = variant ? states[String(variant.id)] : null;
          if (entry) {
            var resolved = entry.state || stateFromInventory(entry);
            return {
              state: resolved,
              label: entry.label || (FULFILMENT_COPY[resolved] || {}).label || '',
              dispatch: entry.dispatch || '',
              last: entry.last === true
            };
          }
          // No map row (a variant the server never saw). The AJAX product endpoint exposes availability
          // but not shop quantity, so only sold and untracked can be told apart here. Never default to
          // made to order — that is what left every sellable variant stuck in one state before.
          var state = (!variant || variant.available === false) ? 'sold' : 'ready';
          var copy = FULFILMENT_COPY[state];
          return {
            state: state,
            label: copy.label,
            dispatch: copy.dispatch,
            last: false
          };
        }

        // "XL / Reflective" — the customer's own wording for the exact variant, taken from the
        // option values rather than from the option names, so a Size-only product never mentions
        // a finish and a three-option product names all three.
        function restockOptionLabel(variant) {
          if (!variant) return '';
          var values = (variant.options || []).filter(function (value) { return String(value || '').trim(); });
          if (values.length) return values.join(' / ');
          return String(variant.title || '').trim();
        }

        function restockCategory() {
          var lower = String((product.product_type || '') + ' ' + (product.title || '')).toLowerCase();
          if (/cargo|trouser|pant/.test(lower)) return 'armoured-cargo';
          if (/armou?red|armor/.test(lower)) return 'armoured-hoodie';
          if (/t-?shirt|\btee\b/.test(lower) && lower.indexOf('hoodie') < 0) return 't-shirt';
          if (/hoodie/.test(lower)) return 'hoodie';
          return '';
        }

        // Everything the waitlist needs to notify THIS variant and nothing else: the
        // variant id is the key, the option values are what the customer is shown.
        function restockPayload(variant, email) {
          var optionValues = {};
          var optionNames = {};
          (variant.options || []).forEach(function (value, index) {
            var name = names[index] || ('Option ' + (index + 1));
            optionNames[String(name)] = String(value || '');
            if (/size/i.test(name)) optionValues.size = String(value || '');
            else if (/print.*(type|finish)|finish/i.test(name) || /reflect/i.test(String(value || ''))) optionValues.printType = String(value || '');
            else if (/colou?r/i.test(name)) optionValues.colour = String(value || '');
          });
          var featured = product.featured_image || (product.images && product.images[0]) || '';
          return {
            email: email,
            variantId: String(variant.id),
            variantTitle: restockOptionLabel(variant),
            productId: String(product.id || details.getAttribute('data-runit-product-id') || ''),
            productHandle: details.getAttribute('data-runit-product-handle') || product.handle || '',
            productTitle: details.getAttribute('data-runit-product-title') || product.title || '',
            productUrl: location.origin + (details.getAttribute('data-runit-product-url') || (product.url || '')),
            productImage: featured && featured.indexOf('//') === 0 ? location.protocol + featured : featured,
            category: restockCategory(),
            size: optionValues.size || '',
            printType: optionValues.printType || '',
            colour: optionValues.colour || '',
            options: optionNames
          };
        }

        // The purchase block's own state, so the badge can be given equal breathing
        // room above and below it when the restock panel is on screen (see
        // [data-runit-stock-state] in assets/runit-tweaks.css).
        function paintStockState(state) {
          if (details) details.setAttribute('data-runit-stock-state', state);
        }

        // One panel, three states: the form, "Saving…", and the confirmation that
        // replaces the form once the storefront has actually stored the address.
        // Never shows a success a request did not earn.
        function paintRestock(variant) {
          if (!restockPanel) return;
          var label = restockOptionLabel(variant);
          if (restockCopy) {
            restockCopy.textContent = label
              ? label + ' is currently sold out.'
              : 'This option is currently sold out.';
          }
          var done = Boolean(variant && restockSubscribed[String(variant.id)]);
          if (restockLead) restockLead.hidden = done;
          if (restockForm) restockForm.hidden = done;
          if (restockDone) restockDone.hidden = !done;
          if (restockMessage) restockMessage.textContent = '';
          if (restockButton) restockButton.disabled = false;
          if (restockEmailInput && done) restockEmailInput.value = '';
        }

        function renderStatus(variant) {
          if (!variant) return;
          var state = fulfilmentStateFor(variant);
          // Personalised pieces are printed to order even when the plain garment is on the shelf
          // (assets/runit-personalise.js sets RLPZ_ON and fires runit:personalise).
          // Personalised pieces dispatch in 2 weeks; Last Sizes ('quick') in 5–7 working days (merchant 2026-10-30).
          if (window.RLPZ_ON && state.state === 'ready') {
            state = { state: 'made', label: FULFILMENT_COPY.made.label, dispatch: window.RLPZ_ON === 'quick' ? 'Dispatched in 5 - 7 working days' : FULFILMENT_COPY.made.dispatch, last: false };
          }
          paintStockState(state.state);
          if (fulfilRoot) {
            fulfilRoot.classList.remove('rl-fulfil--ready', 'rl-fulfil--made', 'rl-fulfil--sold');
            fulfilRoot.classList.add('rl-fulfil--' + state.state);
            fulfilRoot.setAttribute('data-runit-fulfilment-state', state.state);
          }
          if (badge && state.label) badge.textContent = state.label;
          if (dispatch) {
            dispatch.textContent = state.dispatch;
            dispatch.hidden = !state.dispatch;
          }
          if (lastPiece) lastPiece.hidden = !state.last;
          // Restock signup belongs to the sold-out state alone. Made to order stays purchasable and
          // must never be presented as a restock opportunity.
          if (restockPanel) restockPanel.hidden = state.state !== 'sold';
          if (state.state === 'sold') {
            // The panel belongs to one exact variant. Switching options while it is
            // open must re-title it and drop any previous answer, or a customer who
            // asked about XL/Reflective would read a confirmation meant for L.
            if (!restockVariant || restockVariant.id !== variant.id) {
              restockVariant = variant;
              if (restockForm) restockForm.dataset.variantId = String(variant.id);
              paintRestock(variant);
            }
          } else {
            restockVariant = null;
          }
          // Add to cart follows the selected variant: ready and made to order are both purchasable,
          // only out of stock is blocked. The theme owns the label and re-renders it on variant change;
          // this keeps the disabled flag honest in both directions so a switch the theme has not
          // re-rendered can never leave a stale enabled button — or a stale disabled one.
          var button = form.querySelector('button[name="add"]');
          if (button) {
            if (state.state === 'sold') {
              button.disabled = true;
              button.setAttribute('data-unavailable', 'true');
              var closedForm = form.closest('[data-drop-closed="true"]');
              if (closedForm) {
                var label = button.querySelector('.main-atc__label__text');
                if (label) label.textContent = closedForm.getAttribute('data-drop-label') || 'Sold out';
              }
            } else if (button.getAttribute('data-unavailable') === 'true') {
              button.disabled = false;
              button.removeAttribute('data-unavailable');
            }
          }
        }

        function render() {
          var input = form.querySelector('[name="id"]');
          var selected = input && byId[input.value];
          if (!selected) return;
          publishVariant(selected);
          renderStatus(selected);
        }
        document.addEventListener('runit:personalise', function () {
          var input = form.querySelector('[name="id"]');
          if (input && byId[input.value]) renderStatus(byId[input.value]);
        });

        if (restockForm) {
          var restockBusy = false;
          restockForm.addEventListener('submit', function (event) {
            event.preventDefault();
            if (restockBusy) return;
            var emailInput = restockEmailInput;
            var email = emailInput && emailInput.value.trim();
            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
              if (restockMessage) restockMessage.textContent = 'Enter a valid email address.';
              return;
            }
            // Only a variant that is genuinely unbuyable may be waited on. If the
            // customer switched back to something in stock between renders, there is
            // nothing to wait for and no waitlist row is invented.
            var variant = restockVariant;
            var variantState = variant ? fulfilmentStateFor(variant).state : 'sold';
            if (!variant || variantState !== 'sold') {
              if (restockMessage) restockMessage.textContent = 'That option is available again — add it to your bag.';
              return;
            }
            var subscribeUrl = (details.getAttribute('data-runit-inventory-url') || '').trim();
            if (!subscribeUrl || subscribeUrl.indexOf('REPLACE_WITH_') >= 0) {
              if (restockMessage) restockMessage.textContent = 'Restock alerts are not available yet.';
              return;
            }
            var payload = restockPayload(variant, email);
            restockBusy = true;
            if (restockButton) restockButton.disabled = true;
            if (restockMessage) restockMessage.textContent = 'Saving…';
            // The body is JSON but the request must stay a CORS *simple* request: sending
            // `Content-Type: application/json` makes the browser preflight with OPTIONS,
            // Apps Script answers no preflight, and the request never reaches the
            // spreadsheet at all (measured: "Response to preflight request doesn't pass
            // access control check" and the customer was shown nothing). A string body
            // with no content-type header is sent as text/plain, which is safelisted, so
            // the POST arrives and its JSON answer can be read. Leave this header off.
            fetch(subscribeUrl + (subscribeUrl.indexOf('?') >= 0 ? '&' : '?') + 'action=storefrontSubscribe', {
              method: 'POST',
              body: JSON.stringify(payload)
            })
              .then(function (response) { return response.json(); })
              .then(function (result) {
                // The confirmation replaces the form only after the storefront
                // returned ok, never on the strength of having sent the request.
                // "Saving…" is cleared on every path, so it can never be left
                // standing over a finished request.
                if (result && result.ok) {
                  restockSubscribed[String(variant.id)] = true;
                  paintRestock(variant);
                } else if (restockMessage) {
                  restockMessage.textContent = (result && result.message) || 'We couldn’t save that just now. Please try again.';
                }
              })
              .catch(function () {
                if (restockMessage) restockMessage.textContent = 'We couldn’t save that just now. Please try again.';
              })
              .then(function () {
                restockBusy = false;
                if (restockButton) restockButton.disabled = false;
              });
          });
        }

        render();
        // The sticky bar's picker sits outside <product-info>, so watch the document for any control
        // that can change the selected variant rather than only this section.
        document.addEventListener('change', function (event) {
          var target = event.target;
          if (!target) return;
          if (
            target.name === 'id' ||
            target.closest('variant-selects, variant-radios, secondary-variant-select, secondary-variant-select-separate, sticky-atc')
          ) {
            requestAnimationFrame(function () { render(); });
          }
        });
        document.addEventListener('runit:variant-change', function () { render(); });
      })
      .catch(function () { /* The native variant picker and server-rendered note remain available. */ });
  }

  function initHangingQuote() {
    try {
      var t = document.querySelector('.product__info-wrapper h1, .product__title h1, h1.product__title');
      if (t && /^["“‘']/.test(t.textContent.trim())) {
        t.classList.add('rl-hang-quote');
      }
    } catch (e) {
      // never throw
    }
  }

  function initGalleryCount() {
    try {
      var count = document.querySelector('[data-runit-gallery-count]');
      var gallery = document.querySelector('media-gallery');
      var slider = null;
      if (gallery && gallery.dataset && gallery.dataset.section) {
        slider = document.querySelector('#GalleryViewer-' + gallery.dataset.section);
      }
      if (!slider) {
        slider = document.querySelector('.product-media-slider, slider-component.product-media-slider');
      }
      if (!count) return;
      var total = parseInt(count.getAttribute('data-total'), 10);
      if (!total) {
        var parts = String(count.textContent).split('/');
        total = parseInt(parts[1], 10) || 0;
      }
      if (!total) return;
      count.hidden = false;
      function pad(n) { return String(n).padStart(2, '0'); }
      function setIndex(index) {
        var safe = Math.max(0, Math.min(total - 1, Number(index) || 0));
        count.textContent = pad(safe + 1) + ' / ' + pad(total);
      }
      setIndex(0);
      var ul = document.querySelector('ul.product__media-list');
      function syncFromActive() {
        if (!ul) return;
        var active = ul.querySelector('li.product__media-item.is-active');
        if (!active) return;
        var slides = ul.querySelectorAll('li.product__media-item:not(.hidden)');
        var idx = Array.prototype.indexOf.call(slides, active);
        if (idx >= 0) setIndex(idx);
      }
      if (slider) {
        slider.addEventListener('slideChanged', function (event) {
          var idx = 0;
          if (event && event.detail) {
            if (typeof event.detail.current === 'number') idx = event.detail.current;
            else if (event.detail.currentElement && event.detail.currentElement.parentElement) {
              var slides = event.detail.currentElement.parentElement.querySelectorAll('.product__media-item:not(.hidden)');
              idx = Array.prototype.indexOf.call(slides, event.detail.currentElement);
            }
          }
          setIndex(idx);
        });
      }
      // Programmatic scrolls (variant change, finish toggle) can skip slideChanged —
      // track the active slide class directly so the counter never desyncs.
      if (ul && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () { syncFromActive(); });
        mo.observe(ul, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
    } catch (e) {}
  }

  function initStickyAtc() {
    try {
      var bar = document.querySelector('[data-runit-sticky-atc], sticky-atc');
      if (!bar || bar.dataset.runitPurchaseBound) return;
      var container = bar.querySelector('.sticky-atc-container');
      if (!container) return;
      bar.dataset.runitPurchaseBound = 'true';
      var button = bar.querySelector('.main-product-atc');
      var primary = document.querySelector('[id^="ProductSubmitButton-"]');
      var status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('data-runit-sticky-status', '');
      container.appendChild(status);
      var pending = false;
      var added = false;
      function syncFeedback() {
        var loading = (button && button.classList.contains('loading')) ||
          (primary && primary.classList.contains('loading'));
        if (loading) pending = true;
        var label = button && button.querySelector('.sticky-atc__label__text');
        if (label && loading && !added) {
          label.textContent = 'Adding…';
          button.setAttribute('aria-busy', 'true');
          status.textContent = 'Adding to your bag';
        } else if (!loading) {
          if (button) button.removeAttribute('aria-busy');
          if (!added) {
            status.textContent = '';
            syncStickySummary();
          }
          pending = false;
        }
      }
      if (window.MutationObserver) {
        var feedbackObserver = new MutationObserver(syncFeedback);
        [button, primary].forEach(function (control) {
          if (control) feedbackObserver.observe(control, { attributes: true, attributeFilter: ['class', 'disabled'] });
        });
      }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (!pending || !event || event.source !== 'product-form') return;
          added = true;
          status.textContent = 'Added to your bag';
          var label = button && button.querySelector('.sticky-atc__label__text');
          if (label) label.textContent = 'Added ✓';
          window.setTimeout(function () { added = false; syncFeedback(); }, 1600);
        });
      }
      // Shrine already IntersectionObservers the primary ATC via data-after-scroll.
      // Only add blocked() hide rules for drawer / menu / dialog.
      var drawer = document.querySelector('cart-drawer');
      var menu = document.querySelector('details-modal.header__icon--menu, #menu-drawer, .menu-drawer');
      function blocked() {
        var drawerOpen = drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open'));
        var menuEl = document.querySelector('details.menu-opening, details[open].header__icon--menu, #menu-drawer.menu-opening');
        var menuOpen = !!(menu && (menu.hasAttribute('open') || menu.classList.contains('active'))) || !!menuEl;
        var dialogOpen = document.body.classList.contains('runit-dialog-open') ||
          !!document.querySelector('dialog[open].runit-size-chart__dialog');
        return drawerOpen || menuOpen || dialogOpen;
      }
      function syncBlocked() {
        if (window.matchMedia('(min-width: 750px)').matches || blocked()) {
          bar.classList.add('rl-sticky-atc--blocked');
        } else {
          bar.classList.remove('rl-sticky-atc--blocked');
        }
      }
      syncBlocked();
      document.addEventListener('click', syncBlocked);
      document.addEventListener('keyup', syncBlocked);
      window.addEventListener('resize', syncBlocked);
      document.addEventListener('shopify:section:load', syncBlocked);
      if (drawer && window.MutationObserver) {
        new MutationObserver(syncBlocked).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
      }
      if (menu && window.MutationObserver) {
        new MutationObserver(syncBlocked).observe(menu, { attributes: true, attributeFilter: ['class', 'open'] });
      }
    } catch (e) {}
  }

  /* Mobile sticky Add to Bag: show it once the page's real Add to Bag button has
     scrolled up out of view, never while that button is on screen or still below.
     Shrine's own rule watches the plain product-form button, which set-tier PDPs
     hide (their button is the set picker's `.rl-ab__add`), so on those pages the bar
     showed from the top of the page — or, on armour pages, never at all.
     Armour sets: the bar is shown and its button hands off to the set's own button,
     so it adds exactly what the set picker would (2026-10-09). */
  function initStickyHold() {
    try {
      var bar = document.querySelector('sticky-atc');
      if (!bar || bar.dataset.rlHoldBound) return;
      bar.dataset.rlHoldBound = 'true';
      var setRoot = document.querySelector('.rl-ab[data-armour-bundles]');
      var setAdd = document.querySelector('.rl-ab__add[data-bundle-add]');
      var primary = document.querySelector('[id^="ProductSubmitButton-"]');

      if (setRoot && setAdd && /^(armour|cargo)$/.test(setRoot.dataset.kind)) {
        bar.classList.add('rl-sticky-atc--set', 'rl-ab-sticky-set');
        window.addEventListener('click', function (event) {
          if (!event.target.closest || !bar.contains(event.target)) return;
          if (!event.target.closest('.sticky-atc__button, .main-product-atc, button')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          setAdd.click();
          window.setTimeout(function () {
            var drawer = document.querySelector('cart-drawer');
            var opened = drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open'));
            if (!opened) setRoot.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }, 700);
        }, true);
      }

      function shown(el) {
        return !!(el && el.getClientRects().length && window.getComputedStyle(el).visibility !== 'hidden');
      }
      function target() {
        if (shown(setAdd)) return setAdd;
        if (shown(primary)) return primary;
        return null;
      }
      var queued = false;
      function sync() {
        queued = false;
        var button = target();
        var hold = !!button && button.getBoundingClientRect().bottom > 0;
        if (bar.classList.contains('rl-sticky-atc--hold') !== hold) {
          bar.classList.toggle('rl-sticky-atc--hold', hold);
          if (typeof syncStickyMetrics === 'function') syncStickyMetrics();
        }
      }
      function queue() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(sync);
      }
      sync();
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      window.addEventListener('load', queue);
      document.addEventListener('runit:variant-change', queue);
      if (setRoot && window.MutationObserver) {
        new MutationObserver(queue).observe(setRoot, { attributes: true, attributeFilter: ['class'] });
      }
    } catch (e) {}
  }


  // form: only the pickers that drive that form (a quick-add modal's unpicked size must not block the page's).
  function optionGroups(form) {
    return Array.prototype.slice.call(document.querySelectorAll('variant-selects .product-form__input, variant-radios .product-form__input'))
      .filter(function (group) {
        var control = group.querySelector('input[type="radio"], select');
        return !group.classList.contains('hidden') && control && (!form || control.form === form);
      });
  }

  function missingOptionGroup(form) {
    var groups = optionGroups(form);
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');
      if (select && !select.value) return group;
      if (!select && !checked) return group;
    }
    return null;
  }

  function highlightGroup(root) {
    if (!root) return;
    root.classList.add('rl-size-needed');
    var header = document.querySelector('sticky-header, .header, header');
    var offset = (header ? header.getBoundingClientRect().height : 72) + 12;
    var top = root.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    window.setTimeout(function () {
      root.classList.remove('rl-size-needed');
    }, 1800);
  }

  function isReflectiveValue(value) {
    var n = String(value || '').toLowerCase();
    return n.indexOf('reflective') !== -1 && n.indexOf('non') === -1;
  }

  function syncReflectiveNote() {
    var note = document.querySelector('[data-runit-reflective-note]');
    var finish = document.querySelector('[data-runit-print-finish]');
    if (!note || !finish) return;
    var checked = finish.querySelector('input:checked');
    note.hidden = !(checked && isReflectiveValue(checked.value));
  }

  /*
   * Show the selected variant options beneath the sticky price.
   *
   * Read from the pickers themselves (Shopify's own keys: name="id" for the
   * variant, one checked radio / select per option group) rather than from a
   * per-product map, so it works on a product with one option, two, or a future
   * third without naming any of them here. A single-value option Shopify calls
   * "Default Title" is not an option the shopper chose, so it is dropped.
   */
  function selectedOptionValues() {
    var groups = optionGroups();
    var values = [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var select = group.querySelector('select');
      var checked = group.querySelector('input[type="radio"]:checked');
      var value = select ? select.value : (checked ? checked.value : '');
      value = String(value || '').trim();
      if (!value) continue;
      if (/^default title$/i.test(value)) continue;
      if (/^default$/i.test(value) && groups.length > 1) continue;
      if (values.indexOf(value) === -1) values.push(value);
    }
    return values;
  }

  function syncStickySummary() {
    var price = document.querySelector('sticky-atc .sticky-atc__price');
    if (!price) return;
    var values = selectedOptionValues();
    var extra = price.querySelector('[data-runit-sticky-summary]');
    if (!extra) {
      extra = document.createElement('span');
      extra.setAttribute('data-runit-sticky-summary', '');
      extra.className = 'rl-sticky-summary';
      // Keep the options beside the price in the DOM; CSS places them on their own line.
      var money = price.querySelector('.price');
      if (money && money.parentElement === price) money.insertAdjacentElement('afterend', extra);
      else price.appendChild(extra);
    }
    extra.textContent = values.join(' / ');
    extra.hidden = !values.length;
    extra.setAttribute('title', extra.textContent);
    var label = document.querySelector('sticky-atc .sticky-atc__label__text');
    if (label && !label.closest('button').disabled && !label.closest('button').classList.contains('loading')) {
      label.textContent = 'ADD TO BAG';
    }
    syncStickyMetrics();
  }

  /*
   * How tall the sticky Add to cart bar actually is, published to CSS so the
   * blackjack launcher can sit above it instead of over it.
   *
   * Measured from the painted element rather than from a class: this theme keeps
   * the bar in the DOM at all times and hides it with `visibility`, and it also
   * varies with the viewport (it carries env(safe-area-inset-bottom)). Zero means
   * "not on screen", which is what puts the launcher back in its normal corner.
   */
  /* A scroll is a moment, not the answer: the bar is still moving when it
     arrives. Three bounded re-reads (the same pattern the overlay coordinator
     uses for its drawers, and a no-op whenever nothing moved) make the height
     correct once the transition has finished. */
  var stickySettling = 0;
  function settleStickyMetrics() {
    if (stickySettling) return;
    stickySettling = 3;
    [120, 320, 640].forEach(function (ms) {
      window.setTimeout(function () {
        stickySettling -= 1;
        syncStickyMetrics();
      }, ms);
    });
  }

  function syncStickyMetrics() {
    var bar = document.querySelector('[data-runit-sticky-atc], sticky-atc');
    var root = document.documentElement;
    if (!bar) {
      root.style.removeProperty('--rl-sticky-atc-h');
      root.removeAttribute('data-rl-sticky-atc');
      return;
    }
    var style = window.getComputedStyle(bar);
    var rect = bar.getBoundingClientRect();
    var painted = style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    var onScreen = painted && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
    root.style.setProperty('--rl-sticky-atc-h', (onScreen ? Math.round(rect.height) : 0) + 'px');
    if (onScreen) root.setAttribute('data-rl-sticky-atc', 'on');
    else root.removeAttribute('data-rl-sticky-atc');
  }

  function preventIncompleteAdd(event) {
    var submitter = event.target.closest(
      'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[type="submit"], sticky-atc .button, sticky-atc button, [data-runit-sticky-atc] .button, [data-runit-sticky-atc] button, .shopify-payment-button'
    );
    if (!submitter) return;
    // A size renders unpicked until the shopper chooses one (product-variant-picker.liquid), so a
    // checked radio is always a real choice.
    var missing = missingOptionGroup(submitter.form || submitter.closest('form'));
    if (!missing) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    highlightGroup(missing);
    var control = missing.querySelector('input:not(:disabled), select:not(:disabled)');
    if (control) control.focus({ preventScroll: true });
    var status = document.querySelector('[data-runit-sticky-status]');
    var name = missing.querySelector('legend, label');
    if (status) status.textContent = 'Select ' + (name ? name.textContent.trim().toLowerCase() : 'your options') + ' above';
  }

  function initOptionGate() {
    try {
      document.addEventListener('click', preventIncompleteAdd, true);
      document.addEventListener('submit', function (event) {
        if (!event.target.matches || !event.target.matches('form[action*="/cart/add"]')) return;
        var missing = missingOptionGroup(event.target);
        if (!missing) return;
        event.preventDefault();
        event.stopPropagation();
        highlightGroup(missing);
      }, true);
      document.addEventListener('change', function () {
        syncReflectiveNote();
        syncStickySummary();
      });
      document.addEventListener('runit:variant-change', function () {
        syncStickySummary();
        syncStickyMetrics();
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, syncStickySummary);
      }
      window.addEventListener('resize', function () {
        syncStickyMetrics();
        settleStickyMetrics();
      });
      window.addEventListener('scroll', function () {
        syncStickyMetrics();
        settleStickyMetrics();
      }, { passive: true });
      window.addEventListener('load', syncStickyMetrics);
      /* The bar arrives on a 150ms transform transition (base.css), and the
         scroll that triggers it fires while the bar is still a few pixels off
         screen — so the read can report "not on screen" and nothing asks again
         once it has finished arriving. Its own transitionend does. */
      var metricsBar = document.querySelector('[data-runit-sticky-atc], sticky-atc');
      if (metricsBar) metricsBar.addEventListener('transitionend', syncStickyMetrics);
      syncReflectiveNote();
      syncStickySummary();
      syncStickyMetrics();
    } catch (e) {}
  }

  function initFooterAccordions() {
    try {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      document.querySelectorAll('[data-runit-footer-accordion]').forEach(function (button) {
        if (button.dataset.runitBound) return;
        button.dataset.runitBound = 'true';
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
        button.addEventListener('click', function () {
          var open = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!open));
          if (panel) panel.hidden = open;
          button.classList.toggle('is-open', !open);
        });
      });
    } catch (e) {}
  }

  function initVariantUrl() {
    try {
      var info = document.querySelector('product-info[id^="ProductInfo-"]');
      if (!info || info.dataset.runitVariantUrl) return;
      info.dataset.runitVariantUrl = 'true';
      var params = new URLSearchParams(window.location.search);
      var variantParam = params.get('variant');
      if (variantParam) {
        var input = info.querySelector('form[action*="/cart/add"] [name="id"]');
        if (input && String(input.value) !== String(variantParam)) {
          // Shopify Liquid already honours ?variant= on first paint; do not force a mismatch.
        }
      }
      // The page never names a variant in its own URL before the shopper picks one: the load-time
      // publish would otherwise write the unchosen first size.
      var picked = false;
      document.addEventListener('change', function (event) {
        if (event.target && event.target.closest && event.target.closest('variant-selects, variant-radios')) picked = true;
      }, true);
      document.addEventListener('runit:variant-change', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!picked || missingOptionGroup(info.querySelector('form[action*="/cart/add"]'))) return;
        if (!variant || !variant.id || !window.history || !window.history.replaceState) return;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.pathname + '?' + url.searchParams.toString() + url.hash);
      });
    } catch (e) {}
  }

  function capMobileLooxReviews() {
    try {
      var root = document.getElementById('looxReviews');
      if (root) {
        root.setAttribute('data-limit', '8');
        root.setAttribute('data-limit-mobile', '6');
      }
    } catch (e) {}
  }

  function initLooxReviewCap() {
    try {
      capMobileLooxReviews();
    } catch (e) {}
  }

  function initLooxRatingScroll() {
    try {
      var rating = document.querySelector('.loox-rating, [id*="loox"] .loox-rating, .product__info-wrapper [class*="loox"]');
      var reviews = document.querySelector('[id*="1754569464a6f3fd1a"], [id*="loox-dynamic"], .loox-reviews, #runit-reviews');
      if (!rating || !reviews) return;
      rating.style.cursor = 'pointer';
      rating.addEventListener('click', function (event) {
        event.preventDefault();
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    } catch (e) {}
  }

  function placeProductDescription() {
    try {
      var desc = document.querySelector('[data-runit-description]');
      var slot = document.querySelector('[data-runit-desc-slot]');
      var home = document.querySelector('[data-runit-desc-home]');
      if (!desc || !slot || !home) return;
      var desktop = window.matchMedia('(min-width: 750px)').matches;
      if (desktop) {
        if (desc.parentElement !== slot) slot.append(desc);
      } else if (desc.parentElement !== home) {
        home.append(desc);
      }
    } catch (e) {}
  }

  function placeHeaderSearch() {
    try {
      var left = document.querySelector('.header__left');
      var icons = document.querySelector('.header__icons');
      if (!left || !icons) return;
      var search = icons.querySelector('.header__search') || left.querySelector('.header__search');
      if (!search) return;
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      if (mobile) {
        if (search.parentElement !== left) left.appendChild(search);
      } else if (search.parentElement !== icons) {
        icons.insertBefore(search, icons.firstChild);
      }
    } catch (e) {}
  }

  function initHeaderSearchPlacement() {
    placeHeaderSearch();
    window.addEventListener('resize', placeHeaderSearch);
    document.addEventListener('shopify:section:load', placeHeaderSearch);
  }

  function initProductDescription() {
    placeProductDescription();
    window.addEventListener('resize', placeProductDescription);
    document.addEventListener('shopify:section:load', placeProductDescription);
  }

  function init() {
    initHeroLinks();
    initVariantDetails();
    initHangingQuote();
    initGalleryCount();
    initStickyAtc();
    initStickyHold();
    initOptionGate();
    initFooterAccordions();
    initVariantUrl();
    initLooxRatingScroll();
    initLooxReviewCap();
    initProductDescription();
    initHeaderSearchPlacement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== RunIt finish-pair media swap (Print Type: Reflective <-> Non-Reflective) =====
   u360-style: one gallery slide hosts BOTH finish images as layers; switching
   Print Type toggles the visible layer in place. Slide count and positions are
   constant. The Liquid layer renders the pair slide and drops the plain
   non-reflective slide; this JS only syncs state and the modal. */
(function () {
  'use strict';

  function pairData() {
    if (document.querySelector('[data-runit-product-views]')) return null;
    var node = document.querySelector('script[data-rl-finish-pair-data]');
    if (!node) return null;
    try {
      var d = JSON.parse(node.textContent);
      if (!d || !d.reflectiveId || !d.nonreflectiveId) return null;
      d.option = d.option || 'Print Type';
      return d;
    } catch (e) {
      return null;
    }
  }

  function normFinish(value) {
    var v = String(value || '').toLowerCase();
    if (!v) return '';
    if (v.indexOf('non') !== -1 && v.indexOf('reflect') !== -1) return 'nonreflective';
    if (v.indexOf('reflect') !== -1) return 'reflective';
    return '';
  }

  function currentFinish(data) {
    // 1) the marked print-finish picker (pills/swatches/dropdown)
    var wrap = document.querySelector('[data-runit-print-finish]');
    if (wrap) {
      var c = wrap.querySelector('input:checked');
      if (c) return normFinish(c.value);
      var sel = wrap.querySelector('select');
      if (sel) return normFinish(sel.value);
    }
    // 2) radios named after the option itself (theme pills use name="Print Type")
    var esc = window.CSS && CSS.escape ? CSS.escape(data.option) : data.option;
    var radio = document.querySelector(
      'input[type="radio"][name="' + esc + '"]:checked'
    );
    if (radio) return normFinish(radio.value);
    // 3) dropdowns (name="options[Print Type]")
    var dd = document.querySelector('select[name="options[' + esc + ']"]') ||
             document.querySelector('select[name="' + esc + '"]');
    if (dd) return normFinish(dd.value);
    return '';
  }

  function mediaSuffix(el) {
    var parts = String(el.id || '').split('-');
    return parts.length ? parts[parts.length - 1] : '';
  }

  function gallerySlides() {
    return document.querySelectorAll(
      'media-gallery .product__media-item, .product-media-modal ~ * .product__media-item, .product__media-wrapper .product__media-item'
    );
  }

  function syncGallery(data, finish) {
    gallerySlides().forEach(function (li) {
      if (li.getAttribute('data-rl-finish-pair') === 'true') {
        li.classList.remove('hidden');
        li.setAttribute('data-rl-finish-active', finish);
        return;
      }
      var suffix = mediaSuffix(li);
      if (suffix === String(data.nonreflectiveId) || suffix === String(data.reflectiveId)) {
        // Plain finish slides never stand alone once pairing is active.
        li.classList.add('hidden');
        li.classList.remove('is-active');
      }
    });
    // No is-active fallback here: forcing it onto the pair slide while the shopper was on
    // another slide set the counter to 01 on every size change. media-gallery.js no longer
    // clears is-active when the variant's photo is not a slide.
  }

  function syncModal(data, finish) {
    var items = document.querySelectorAll(
      '.product-media-modal__content [data-media-id]'
    );
    items.forEach(function (item) {
      var id = item.getAttribute('data-media-id');
      var isRef = id === String(data.reflectiveId);
      var isNon = id === String(data.nonreflectiveId);
      if (!isRef && !isNon) return;
      var want = (finish === 'reflective' && isRef) ||
                 (finish === 'nonreflective' && isNon);
      item.toggleAttribute('hidden', !want);
    });
  }

  function bindModalTargeting(data) {
    document.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      var opener = ev.target.closest(
        '.product__media-item[data-rl-finish-pair="true"] modal-opener, .product__media-item[data-rl-finish-pair="true"] .product__media-toggle'
      );
      if (!opener) return;
      var finish = currentFinish(data) || 'reflective';
      var id = finish === 'reflective' ? data.reflectiveId : data.nonreflectiveId;
      opener.setAttribute('data-media-id', id);
      var toggle = opener.classList.contains('product__media-toggle')
        ? opener
        : opener.querySelector('.product__media-toggle');
      if (toggle) toggle.setAttribute('data-media-id', id);
    }, true);
  }

  function apply() {
    var data = pairData();
    if (!data) return;
    var finish = currentFinish(data) || 'reflective';
    syncGallery(data, finish);
    syncModal(data, finish);
  }

  // Choosing a finish shows it: go back to the pair slide (always slide 1) through the
  // gallery's own setActiveMedia, so thumbnails, the mobile slider and a stacked layout
  // all move the way they do for a thumbnail tap. The theme's variant change cannot do
  // this — the variants' featured media is the plain finish photo, which is not a slide.
  function showPairSlide() {
    var li = document.querySelector('media-gallery .product__media-item[data-rl-finish-pair="true"]');
    var gallery = li && li.closest('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(li.getAttribute('data-media-id'), false);
    }
  }

  function isFinishControl(t, data) {
    var name = t.getAttribute('name') || '';
    return name === data.option || name === 'options[' + data.option + ']' ||
           !!(t.closest && t.closest('[data-runit-print-finish]'));
  }

  function init() {
    var data = pairData();
    if (!data) return;
    apply();
    bindModalTargeting(data);

    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.getAttribute) return;
      var name = t.getAttribute('name') || '';
      var hit = name.indexOf('options[') === 0 || name === data.option ||
                (t.closest && (t.closest('[data-runit-print-finish]') ||
                               t.closest('[data-runit-size-option]')));
      if (!hit) return;
      var finishPicked = isFinishControl(t, data);
      requestAnimationFrame(function () {
        apply();
        if (finishPicked) showPairSlide();
      });
    });
    // Re-tapping the finish already chosen fires no change but is still a choice.
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t && t.matches && t.matches('input[type="radio"]:checked') && isFinishControl(t, data)) {
        requestAnimationFrame(showPairSlide);
      }
    });

    window.rlFinishPair = { apply: apply, data: data };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== Collection rows: horizontal wheel/trackpad scrolling =====
   The theme's Splide rows only move on arrow click or drag, so a desktop
   mouse wheel or trackpad swipe did nothing and a long row (a whole
   collection, ~12 pages) was effectively unreachable. Horizontal wheel
   intent is forwarded to the row's own arrows, leaving the theme's
   navigation and pagination logic untouched. Vertical wheel is left alone. */
(function () {
  'use strict';

  var COOLDOWN = 150;   // verified 1 step per tick down to 120ms
  var DESKTOP = 990;
  var lastStep = 0;

  function componentFor(target) {
    return target && target.closest ? target.closest('splide-component') : null;
  }

  function step(comp, dir) {
    var btn = comp.querySelector(dir > 0 ? '.splide__arrow--next' : '.splide__arrow--prev');
    if (btn && !btn.disabled) btn.click();
  }

  function onWheel(ev) {
    if (ev.ctrlKey) return;                       // pinch / browser zoom
    var comp = componentFor(ev.target);
    if (!comp) return;
    // Rows running as a native rail (no Splide arrows) scroll themselves —
    // never intercept those, the browser's own momentum is the point.
    if (!comp.querySelector('.splide__arrow--next')) return;

    var dx = ev.deltaX;
    var dy = ev.deltaY;
    var shifted = ev.shiftKey && Math.abs(dy) >= Math.abs(dx);
    if (!shifted && Math.abs(dx) <= Math.abs(dy)) return;   // vertical intent

    var track = comp.querySelector('.splide__track');
    if (!track || track.scrollWidth <= track.clientWidth) return;
    // Only hijack on desktop; mobile keeps its native gestures.
    if (window.innerWidth < DESKTOP && !shifted) return;

    ev.preventDefault();
    var now = Date.now();
    if (now - lastStep < COOLDOWN) return;
    lastStep = now;
    step(comp, (shifted ? dy : dx) > 0 ? 1 : -1);
  }

  function init() {
    document.addEventListener('wheel', onWheel, { passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== Homepage collection rows: desktop rail + position bar =====
   Above 749px these sections now run with the theme's desktop slider OFF, so
   the list is left as a plain grid. Turn that grid into a native horizontal
   scroller: the browser supplies real momentum for trackpad and wheel (one
   continuous movement, never stepped card-by-card), and we add paging arrows
   plus a bar under the row that shows how far along the customer is.
   Mobile keeps the theme's slider exactly as it was. */
(function () {
  'use strict';

  var MIN = 750;
  var MARK = 'data-rl-rail';
  // How long the position bar lingers after the row stops. Was 900ms, which the
  // client read as the bar sitting around after the movement had finished — the
  // cue is "the row is moving", so it now leaves sooner. The CSS opacity
  // transition is shortened to match (0.28s -> 0.2s), so the two together are
  // ~0.7s end to end instead of ~1.2s.
  var HIDE_MS = 480;
  var ARROW_PATH = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';

  function isDesktop() {
    return window.matchMedia('(min-width: ' + MIN + 'px)').matches;
  }

  function railRows() {
    return [].slice.call(document.querySelectorAll('[id*="__featured_collection"] splide-component, [id*="__rl_clearance_rail"] splide-component, [id*="__rl_coming_back"] splide-component'));
  }

  function buildArrow(dir, colour) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-rl-arrow', dir);
    btn.setAttribute('aria-label', dir === 'prev' ? 'Previous products' : 'Next products');
    btn.className = 'splide__arrow splide__arrow--' + dir + (colour ? ' ' + colour : '');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false" aria-hidden="true"><path d="' + ARROW_PATH + '"></path></svg>';
    return btn;
  }

  function arrowHost(splide) {
    var host = splide.querySelector('.splide__arrows');
    if (!host) {
      host = document.createElement('div');
      host.className = 'splide__arrows';
      host.setAttribute('data-rl-host', 'true');
      splide.appendChild(host);
    }
    return host;
  }

  /* An empty arrow container must not survive into a mobile mount: Splide finds
     it, assumes the arrows are already rendered and never builds its own, so the
     slidemoves but shows no chevrons. */
  function dropEmptyArrowHosts(splide) {
    if (!splide) return;
    [].slice.call(splide.querySelectorAll('.splide__arrows')).forEach(function (host) {
      if (!host.querySelector('button')) host.parentNode.removeChild(host);
    });
  }

  function sync(state) {
    var list = state.list;
    // Measure the ROW, never the bar. The bar is `display: none` until
    // data-ready flips (see the CSS), so reading its own clientWidth always
    // returned 0, `if (!trackW) return` bailed, data-ready was never set and the
    // cue could never appear at all. It only ever "worked" in the suite because
    // that suite printed `ready: false` in its output and never asserted it.
    // Once shown, the bar can be narrower than the row (inset on phones).
    var trackW = state.bar.clientWidth || list.clientWidth;
    var visible = list.clientWidth;
    var total = list.scrollWidth;
    if (!trackW) return;
    var ratio = total > visible ? visible / total : 1;
    var thumbW = Math.max(28, Math.round(trackW * ratio));
    var span = total - visible;
    var frac = span > 8 ? list.scrollLeft / span : 0;
    state.thumb.style.width = thumbW + 'px';
    state.thumb.style.transform = 'translateX(' + Math.round(frac * (trackW - thumbW)) + 'px)';
    if (state.prev) state.prev.disabled = list.scrollLeft <= 4;
    if (state.next) state.next.disabled = span > 8 ? list.scrollLeft >= span - 4 : true;
    // Nothing to move through: no bar at all rather than an empty rail.
    state.bar.setAttribute('data-ready', span > 8 ? 'true' : 'false');
  }

  /* The bar is a movement cue: show it while the row is being moved, then let it
     fade out shortly after the movement stops. Only real horizontal input calls
     this — a resize or a fresh mount must not light it up. */
  function flash(state, ms) {
    state.bar.setAttribute('data-active', 'true');
    clearTimeout(state.hideTimer);
    state.hideTimer = setTimeout(function () {
      state.bar.setAttribute('data-active', 'false');
    }, ms || HIDE_MS);
  }

  function teardown(comp) {
    var state = comp.__rlRail;
    if (!state) return;
    if (state.onScroll) state.list.removeEventListener('scroll', state.onScroll);
    if (state.onResize) window.removeEventListener('resize', state.onResize);
    clearTimeout(state.hideTimer);
    if (state.ro) state.ro.disconnect();
    if (state.bar && state.bar.parentNode) state.bar.parentNode.removeChild(state.bar);
    [].slice.call(comp.querySelectorAll('[data-rl-arrow]')).forEach(function (b) {
      if (b.parentNode) b.parentNode.removeChild(b);
    });
    dropEmptyArrowHosts(comp.querySelector('.splide'));
    comp.__rlRail = null;
    comp.setAttribute(MARK, 'false');
  }

  /* Crossing back below the rail breakpoint: Splide never mounts for mobile when
     the desktop instance was pre-empted by the section's responsive `destroy`
     option, which leaves the mobile row looking like a slider but inert. Re-run
     the component's own initialiser on that transition only. */
  function ensureMobileSlider(comp) {
    if (comp.dataset.destroyMobile === 'true') return;
    [].slice.call(comp.querySelectorAll('[data-rl-arrow]')).forEach(function (btn) {
      if (btn.parentNode) btn.parentNode.removeChild(btn);
    });
    dropEmptyArrowHosts(comp.querySelector('.splide'));
    if (typeof comp.initSlider === 'function') comp.initSlider();
  }

  function setup(comp) {
    var splide = comp.querySelector('.splide');
    var list = splide && comp.querySelector('.splide__list');
    if (!splide || !list) return;

    var desktop = isDesktop();
    var mode = desktop ? 'rail' : 'slider';
    if (comp.__rlMode && comp.__rlMode !== mode && mode === 'slider') {
      ensureMobileSlider(comp);
    }
    comp.__rlMode = mode;

    // Homepage rows are native on phones too (splide--rl-native-mobile); arrows stay
    // a desktop affordance, a swipe is the phone one.
    var native = getComputedStyle(list).overflowX === 'auto';
    if (!native) { teardown(comp); return; }
    if (comp.__rlRail && comp.__rlRail.desktop !== desktop) teardown(comp);
    if (comp.__rlRail) { sync(comp.__rlRail); return; }

    var track = splide.querySelector('.splide__track');
    var bar = document.createElement('div');
    bar.className = 'rl-row-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.setAttribute('data-ready', 'false');
    var thumb = document.createElement('span');
    thumb.className = 'rl-row-progress__thumb';
    bar.appendChild(thumb);
    if (track && track.parentNode) track.parentNode.insertBefore(bar, track.nextSibling);
    else splide.appendChild(bar);

    var prev = null;
    var next = null;
    if (desktop) {
      var host = arrowHost(splide);
      var colour = comp.dataset.arrowsColor ? 'color-' + comp.dataset.arrowsColor : '';
      prev = buildArrow('prev', colour);
      next = buildArrow('next', colour);
      host.appendChild(prev);
      host.appendChild(next);
      prev.addEventListener('click', function () {
        list.scrollBy({ left: -list.clientWidth, behavior: 'smooth' });
        flash(state, 1400);
      });
      next.addEventListener('click', function () {
        list.scrollBy({ left: list.clientWidth, behavior: 'smooth' });
        flash(state, 1400);
      });
    }

    var state = { list: list, bar: bar, thumb: thumb, prev: prev, next: next, desktop: desktop };
    var frame = 0;
    state.onScroll = function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = 0; sync(state); flash(state); });
    };
    state.onResize = function () { sync(state); };
    list.addEventListener('scroll', state.onScroll, { passive: true });
    window.addEventListener('resize', state.onResize);
    if (window.ResizeObserver) {
      state.ro = new ResizeObserver(function () { sync(state); });
      state.ro.observe(list);
    }
    comp.__rlRail = state;
    comp.setAttribute(MARK, 'true');
    var firstCard = list.querySelector('img');
    if (firstCard && !firstCard.complete) firstCard.addEventListener('load', function () { sync(state); });
    sync(state);
  }

  function refresh() {
    railRows().forEach(setup);
  }

  function init() {
    refresh();
    var t = 0;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(refresh, 150);
    });
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('load', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Cart drawer items refresh (2026-09-29). main.js gives cart-drawer-items the cart PAGE's
   onCartUpdate: on every cartUpdate it fetches /cart?section_id=main-cart-items and pastes that
   <cart-items> into the drawer, so "Your cart / Continue shopping / PRODUCT TOTAL" showed up in
   the bag whenever that fetch finished last. The drawer re-reads its own section instead (as
   Dawn does). main.js is minified and not edited, so this sets the method on the drawer class. */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('cart-drawer-items').then(function () {
    var C = customElements.get('cart-drawer-items');
    if (!C || Object.prototype.hasOwnProperty.call(C.prototype, 'onCartUpdate')) return;
    C.prototype.onCartUpdate = function () {
      var self = this;
      var url = ((window.routes && window.routes.cart_url) || '/cart') + '?section_id=cart-drawer';
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var src = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer-items');
          if (src) self.innerHTML = src.innerHTML;
        })
        .catch(function () {});
    };
  });
})();

/* Bag and cart page: pressing - at quantity 1 removes the line (the bin buttons are hidden, owner 22 Oct).
   The cart page's input has min 1, so the theme's minus did nothing there and the old "hide the 0" left an
   empty box: at 1 we press the row's own remove control instead, which the theme and runit-bag-v2 already handle. */
document.addEventListener('click', function (event) {
  var minus = event.target.closest && event.target.closest('.cart-quantity button[name="minus"], quantity-input button[name="minus"]');
  if (!minus) return;
  var input = minus.parentElement && minus.parentElement.querySelector('input');
  if (!input || Number(input.value) > 1) return;
  var row = minus.closest('.cart-item, .cart-drawer-item');
  var remove = row && row.querySelector('cart-remove-button a, cart-remove-button button');
  if (!remove) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  input.style.color = 'transparent'; // no half-clipped digit while the row collapses
  remove.click();
}, true);
